import axios from "axios";
import {ACCOUNT_ENUMS} from "utils";

export const authService = {
    signUp: (body) => axios.post("/user", body),

    signIn: (body) => axios.post("/authn/signin", body),

    logOut: () => axios.post(`/authn/logout`, {}, {auth: true}),

    getLink: (email) => axios.get(`/authn/forgotPassword/${email}`),

    resetPass: (info) => axios.post(
        "/authn/resetPassword",
        {...info},
        {headers: {"reset-token": info.token}},
    ),

    confirmAccount: (info) =>
        axios.post(
            "/authn/resetPassword",
            {...info},
            {headers: {"reset-token": info.token}},
        ),

    changePasswordService: (data) =>
        axios.post("/authn/changePassword", data, {auth: true}),

    myProfileService: (type) =>
        axios.get(
            type === ACCOUNT_ENUMS.ADMIN
                ? `/admins/myProfile`
                : "/employees/myProfile",
            {
                auth: true,
            },
        ),

    inviteUserService: (params) =>
        axios.patch(`/users/invite`, params, {auth: true}),

    resetPasswordUserEmployService: (id, body) =>
        axios.patch(`/authn/${id}/password`, body, {auth: true}),
};
